import axios from 'axios'
import { showLoadingToast,closeToast} from 'vant';
import {i18n} from '@/i18n/i18n';
const { t } = i18n.global;

// 创建一个 axios 实例
const service = axios.create({
 
	 baseURL: 'https://www.svip-movie.com', // 生产环境直接请求
	staticbaseURL: 'https://www.svip-movie.com',
	timeout: 600000, // 请求超时时间毫秒
	withCredentials: true // 异步请求携带cookie
})

// 添加请求拦截器
service.interceptors.request.use(
	(config)=>{
        let token = sessionStorage.getItem('token')
        if (token) {
            config.headers['token'] = token
		}
        var lang = localStorage.getItem('lang')|| 'es-es'
		if(lang){
			config.params = {
				...config.params,
				lang:lang
			  }
			config.headers['lang'] = lang
		}
		showLoadingToast({
			message: t('loading')+'...',
			forbidClick: true,
		  });
		return config
	},
	(err)=>{
		console.log(err)
		return Promise.reject(err)
	}
)

// 添加响应拦截器
service.interceptors.response.use(
	(response)=>{
		closeToast()
		return response
	},
	(err)=>{
		closeToast()	//清除加载
		console.log(err)
		return Promise.reject(err)
	}
)
export default service